import { Flex } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const GridMinContent = styled(Flex)`
    min-width: min-content;
`;
